import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { Form } from './Form'
import { Schema, schema, schemaDefault } from './schema'
import { useUpdateAdUnitRefresher } from './useUpdateAdUnitRefresher'

export const FormContainer = (): JSX.Element => {
  const { adUnit, formId, loading, setTouched, setValid } = useContext(AddEditAdUnitContext)
  const { errors: apiErrors, update } = useUpdateAdUnitRefresher()

  if (!adUnit) {
    return <Loading />
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(adUnit)}
    >
      {() => <Form />}
    </FormProvider>
  )
}
